import React, { useState, useEffect, useRef } from "react";
import {
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  FormControl,
  ListItemText,
  Card,
  Box,
} from "@mui/material";
import axios from "axios";
import {
  StyledButton,
  StyledInputLabel,
  StyledSelect,
  StyledTextField,
  StyledCheckbox,
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledDatePicker,
  OutlinedIconFab,
  StyledMultilineTextField,
  StyledTableContainer,
} from "../StyledComponents";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { durationType } from "../initialData/initialData";
import { getHumanReadableDiffInPastDateWithAgo } from "../Utils/UtilsFunctions";
import Icon from "../Utils/Icons";
import DurationAutocompleteField from "./DurationAutocompleteField";
import {
  durationUnitMap,
  normalizeLegacyDuration,
  parseCombinedDuration,
} from "./durationUtils";
const DrugHistorySimplified = ({
  drugHistoryData,
  setDrugHistoryData,
  activeHistorySection,
  setActiveHistorySection,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Drug History called", drugHistoryData);
  const today = dayjs();
  const [drugType, setDrugType] = useState({
    branded: true,
    generic: true,
  });
  const [drugName, setDrugName] = useState("");
  const [drugVars, setDrugVars] = useState({
    drug_description: "",
    drug_name: "",
    onset_datetime: null,
    abatement_datetime: null,
    clinical_note: "",
    duration: "",
    condition_onset: "",
  });
  const [drugEditIndex, setDrugEditIndex] = useState(null);
  const [drugError, setDrugError] = useState("");
  const hasPendingDurationSelection = (durationValue) =>
    /^\d+$/.test(String(durationValue || "").trim());

  const handleAddDrugRow = async () => {
    if (
      hasPendingDurationSelection(drugVars.duration) ||
      hasPendingDurationSelection(drugVars.condition_onset)
    ) {
      setDrugError("Please select a duration");
      return;
    }
    if (drugVars.drug_name || drugName.length > 0) {
      // Store the updated state in a local variable
      let newDetails = {
        ...drugVars,
        id: null,
      };

      const newRow = {
        drug_description: newDetails.drug_description,
        drug_name: newDetails.drug_name,
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),
        abatement_datetime:
          newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
        clinical_note: newDetails?.clinical_note,
        duration: normalizeLegacyDuration(
          newDetails?.duration,
          newDetails?.duration,
          newDetails?.durationType
        ),
        condition_onset: normalizeLegacyDuration(
          newDetails?.condition_onset,
          newDetails?.condition_onset,
          newDetails?.condition_onset_type
        ),
      };

      // Update family history rows by adding the new row

      const updatedRows = [...drugHistoryData["new"], newRow];

      setDrugHistoryData({
        ...drugHistoryData,
        new: updatedRows,
      });
      // Reset family history variables and clear error
      setDrugVars({
        drug_description: "",
        drug_name: "",
        onset_datetime: null,
        abatement_datetime: null,
        clinical_note: "",
        duration: "",
        condition_onset: "",
      });
      setDrugError("");
      setDrugName("");
    } else {
      // Set error message if any field is missing
      setDrugError("Drug Name field is required");
    }
  };
  const handleDrugEditClick = (row, rowIndex) => {
    console.log("Drug Edit Click", row);
    setDrugName(row.drug_name);
    setDrugVars({
      drug_description: row.drug_description,
      drug_name: "",
      onset_datetime: row.onset_datetime ? dayjs(row.onset_datetime) : null,
      abatement_datetime: row.abatement_datetime
        ? dayjs(row.abatement_datetime)
        : null,
      clinical_note: row?.clinical_note,
      duration: normalizeLegacyDuration(row?.duration, row?.duration, row?.durationType),
      condition_onset: normalizeLegacyDuration(
        row?.condition_onset,
        row?.condition_onset,
        row?.condition_onset_type
      ),
    });

    setDrugEditIndex(rowIndex);
  };
  console.log("Drug Edit Index", drugEditIndex, drugName, drugVars.drug_name);
  const handleDrugUpdate = async () => {
    if (
      hasPendingDurationSelection(drugVars.duration) ||
      hasPendingDurationSelection(drugVars.condition_onset)
    ) {
      setDrugError("Please select a duration");
      return;
    }
    if (drugVars.drug_name || drugName.length > 0) {
      // Store the updated state in a local variable

      let newDetails;

      newDetails = { ...drugVars, source: undefined };

      const updatedRow = {
        drug_description: newDetails.drug_description,
        drug_name: newDetails.drug_name,
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),
        abatement_datetime:
          newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
        clinical_note: newDetails?.clinical_note,
        duration: normalizeLegacyDuration(
          newDetails?.duration,
          newDetails?.duration,
          newDetails?.durationType
        ),
        condition_onset: normalizeLegacyDuration(
          newDetails?.condition_onset,
          newDetails?.condition_onset,
          newDetails?.condition_onset_type
        ),
        source: undefined,
      };
      const updatedDrug = drugHistoryData["new"].map((row, index) => {
        if (index === drugEditIndex) {
          return updatedRow;
        } else {
          return row;
        }
      });
      setDrugHistoryData({
        ...drugHistoryData,
        new: updatedDrug,
      });
      // Reset family history variables and clear error
      setDrugVars({
        drug_description: "",
        drug_name: "",
        onset_datetime: null,
        abatement_datetime: null,
        clinical_note: "",
        duration: "",
        condition_onset: "",
      });
      setDrugEditIndex(null);
      setDrugName("");
      setDrugError("");
    } else {
      // Set error message if any field is missing
      setDrugError("Drug Name field is required");
    }
  };
  const handleDrugDelete = (rowIndex) => {
    // Filter out the row at the specified index
    const updatedDrug = drugHistoryData["new"].filter(
      (row, index) => index !== rowIndex
    );
    // Update the state with the filtered array
    setDrugHistoryData({
      ...drugHistoryData,
      new: updatedDrug,
    });
  };
  // const handleChangeDrug = (field, value) => {
  //   if (field === "drug_name") {
  //     setAutoCompleteData([]);
  //     setFilteredOptions([]);
  //     setTermSelectedOrAdded(true);
  //   }
  //   setDrugVars({
  //     ...drugVars,
  //     [field]: value, // Use computed property name to set the field dynamically
  //   });
  // };
  const handleChangeDrug = (field, value) => {
    let updatedDetails = { ...drugVars, [field]: value };

    if (field === "duration") {
      const onsetParsed = parseCombinedDuration(updatedDetails.condition_onset);
      const durationParsed = parseCombinedDuration(updatedDetails.duration);
      const calculatedOnset =
        onsetParsed.value && onsetParsed.unit
          ? calculateOnsetDate(parseInt(onsetParsed.value, 10), onsetParsed.unit)
          : null;
      updatedDetails.onset_datetime = calculatedOnset ?? null;
      if (
        updatedDetails.onset_datetime &&
        durationParsed.value &&
        durationParsed.unit
      ) {
        updatedDetails.abatement_datetime =
          calculateAbatementDate(
            updatedDetails.onset_datetime,
            parseInt(durationParsed.value, 10),
            durationParsed.unit
          ) ?? null;
      } else {
        updatedDetails.abatement_datetime = null;
      }
    } else if (field === "duration") {
      updatedDetails.onset_datetime = null;
      updatedDetails.abatement_datetime = null;
    }

    if (
      field === "condition_onset"
    ) {
      const onsetParsed = parseCombinedDuration(updatedDetails.condition_onset);
      const durationParsed = parseCombinedDuration(updatedDetails.duration);
      updatedDetails.onset_datetime =
        onsetParsed.value && onsetParsed.unit
          ? calculateOnsetDate(
            parseInt(onsetParsed.value, 10),
            onsetParsed.unit
          )
          : null;
      if (
        updatedDetails.onset_datetime &&
        durationParsed.value &&
        durationParsed.unit
      ) {
        updatedDetails.abatement_datetime =
          calculateAbatementDate(
            updatedDetails.onset_datetime,
            parseInt(durationParsed.value, 10),
            durationParsed.unit
          ) ?? null;
      } else {
        updatedDetails.abatement_datetime = null;
      }
    } else if (field === "condition_onset") {
      updatedDetails.onset_datetime = null;
      updatedDetails.abatement_datetime = null;
    }

    setDrugVars(updatedDetails);
  };
  const calculateOnsetDate = (duration, type) => {
    if (!duration) return null;
    const today = dayjs(); // Current date
    console.log("date onset", today.subtract(duration, durationUnitMap[type]));
    return today.subtract(duration, durationUnitMap[type]);
  };

  const calculateAbatementDate = (onset_datetime, duration, type) => {
    if (!duration || isNaN(parseInt(duration)) || !onset_datetime) return null;
    return dayjs(onset_datetime).add(duration, durationUnitMap[type]);
  };

  console.log("Drug Vars Details", drugVars);
  const handleClearMedicineName = () => {
    setDrugError("");
    setDrugName("");
    setDrugVars({
      ...drugVars,
      drug_name: "", // Use computed property name to set the field dynamically
    });
  };

  //   const handleAddOption = async (term) => {
  //     let semanticTagForMedicineSearch =
  //       drugType.branded && drugType.generic
  //         ? "real clinical drug++clinical drug"
  //         : drugType.branded
  //         ? "real clinical drug"
  //         : drugType.generic
  //         ? "clinical drug"
  //         : "";
  //     const postBody = {
  //       term: term,
  //       state: "active",
  //       semantictag: semanticTagForMedicineSearch,
  //       acceptability: "synonyms",
  //       returnlimit: "-1",
  //       refsetid: null,
  //       parentid: null,
  //       excludeparentconcept: false,
  //       fullconcept: true,
  //     };

  //     try {
  //       if (drugName.length > 2) {
  //         const response = await axios.post(
  //           `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
  //           postBody,
  //           { headers: headers }
  //         );
  //         if (response) {
  //           let updatedFound = {},
  //             updatedSelectedOptiondetsils = {},
  //             foundData = false;
  //           console.log("Snomed Response", response);
  //           if (
  //             response.data.status === "Success" &&
  //             response.data.data.length > 0
  //           ) {
  //             foundData = response.data.data.find((d) => d.term === term);
  //             console.log("Found Data", foundData);
  //             if (foundData) {
  //               updatedFound = {
  //                 ...foundData,
  //                 found: true,
  //                 id: foundData.conceptId,
  //               };
  //             } else {
  //               updatedSelectedOptiondetsils = {
  //                 hierarchy: null,
  //                 isPreferredTerm: null,
  //                 conceptState: null,
  //                 conceptFsn: term,
  //                 definitionStatus: null,
  //                 conceptId: null,
  //                 languageCode: "en",
  //                 typeId: null,
  //                 term: term,
  //                 caseSignificanceId: "CASE_INSENSITIVE",
  //                 id: null,
  //                 effectiveTime: null,
  //                 activeStatus: null,
  //                 moduleId: null,
  //               };
  //             }
  //           } else {
  //             updatedSelectedOptiondetsils = {
  //               hierarchy: null,
  //               isPreferredTerm: null,
  //               conceptState: null,
  //               conceptFsn: term,
  //               definitionStatus: null,
  //               conceptId: null,
  //               languageCode: "en",
  //               typeId: null,
  //               term: term,
  //               caseSignificanceId: "CASE_INSENSITIVE",
  //               id: null,
  //               effectiveTime: null,
  //               activeStatus: null,
  //               moduleId: null,
  //             };
  //           }

  //           setAutoCompleteData([]);
  //           setFilteredOptions([]);
  //           setSuggestApiCalled(false);
  //           setDebounceFunctionCalled(true);
  //           if (foundData) {
  //             handleChangeDrug("drug_name", updatedFound.term);
  //           } else {
  //             handleChangeDrug("drug_name", updatedSelectedOptiondetsils.term);
  //           }
  //         }
  //       }
  //     } catch (err) {
  //       console.log(err);
  //       toast.error(err);
  //     }
  //   };
  const handleClearClinicalNotes = () => {
    setDrugError("");
    setDrugVars({
      ...drugVars,
      clinical_note: "", // Use computed property name to set the field dynamically
    });
  };

  const handleConditionTyped = (value) => {
    setDrugName(value);
    handleChangeDrug("drug_name", value);
  };

  return (
    <Card
      sx={{
        borderRadius: "10px",
        boxShadow: "0 4px 4px 0 #C7C7CC inset",
        backgroundColor: "#FFF",
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}
      >
        <Grid item xs={11} sm={11} md={11} sx={{ margin: "5px 0px" }}>
          <StyledTextField
            label="Drug Name"
            variant="outlined"
            value={drugName}
            onChange={(e) => {
              handleConditionTyped(e.target.value);
            }}
            fullWidth
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearMedicineName}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>
                </div>
              ),
            }}
          />
        </Grid>

        <Grid item xs={11} md={11} sm={11}>
          <StyledTextField
            // id="outlined-multiline-static"
            variant="outlined"
            label="Clinical Notes"
            // multiline
            // rows={2}
            value={drugVars.clinical_note}
            onChange={(e) => handleChangeDrug("clinical_note", e.target.value)}
            fullWidth
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearClinicalNotes}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>
                </div>
              ),
            }}
          />
        </Grid>

        <Grid container item xs={12} spacing={1} alignItems="center">
          <Grid
            item
            xs={11}
            sm={11}
            md={5}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Tooltip title="How long ago this drug was started">
              <Typography
                component="span"
                variant="body2"
                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
              >
                Drug Onset:
              </Typography>
            </Tooltip>
            <Box sx={{ flex: 1, minWidth: { xs: 0, sm: 180, md: 200 } }}>
              <DurationAutocompleteField
                label="Duration"
                value={drugVars.condition_onset || ""}
                onChange={(combined) =>
                  handleChangeDrug("condition_onset", combined)
                }
                durationType={durationType}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={11}
            sm={11}
            md={6}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Tooltip title="How long the drug has been taken">
              <Typography
                component="span"
                variant="body2"
                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
              >
                Drug Duration:
              </Typography>
            </Tooltip>
            <Box sx={{ flex: 1, minWidth: { xs: 0, sm: 180, md: 200 } }}>
              <DurationAutocompleteField
                label="Duration"
                value={drugVars.duration || ""}
                onChange={(combined) => handleChangeDrug("duration", combined)}
                durationType={durationType}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={11}
            sm={11}
            md={2}
            sx={{
              margin: "5px 0px",
              display: "flex",
              justifyContent: { xs: "stretch", md: "flex-end" },
              padding: "0px",
            }}
          >
            <StyledButton
              bgColor="#0E3F66"
              variant="contained"
              sx={{ width: { xs: "100%" }, marginLeft: { md: "auto" } }}
              onClick={
                drugEditIndex !== null ? handleDrugUpdate : handleAddDrugRow
              }
              color="defaultColor"
            >
              {drugEditIndex !== null ? "Update" : "Add"}
            </StyledButton>
          </Grid>
        </Grid>

        <Grid item xs={11} md={3} sx={{ margin: "5px 0px", display: "none" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <StyledDatePicker
                label="Date Asserted"
                onChange={(date) => handleChangeDrug("onset_datetime", date)}
                slotProps={{
                  field: { clearable: true },
                }}
                maxDate={today}
                value={
                  drugVars?.onset_datetime
                    ? dayjs(drugVars?.onset_datetime)
                    : null
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid>
        {/* <Grid item xs={12} md={3} sx={{ margin: "5px 0px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <StyledDatePicker
                fullWidth
                label="End Date"
                onChange={(date) =>
                  handleChangeDrug("abatement_datetime", date)
                }
                slotProps={{
                  field: { clearable: true },
                }}
                maxDate={today}
                minDate={dayjs(drugVars.onset_datetime)}
                value={
                  drugVars?.abatement_datetime
                    ? dayjs(drugVars?.abatement_datetime)
                    : null
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid> */}
        <Grid item xs={11} md={11} sm={11}>
          {drugError && (
            <Typography style={{ color: "red" }}>{drugError}</Typography>
          )}
        </Grid>
        <Grid item xs={11} sm={11}>
          {drugHistoryData["prev"].length > 0 && (
            <StyledTableContainer
              component={Paper}
            // sx={{
            //   marginTop: "20px",
            //   border: "1px solid #21cdc0",
            // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Drug Name</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>Drug Onset</StyledTableCellHistory>
                    <StyledTableCellHistory>Drug Duration</StyledTableCellHistory>
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {drugHistoryData["prev"].map((row, rowIndex) => {
                    // console.log("Drug Row", row); // Logging the row object

                    return (
                      <StyledTableRowHistory key={rowIndex}>
                        <StyledTableCellHistory>
                          {row?.drug_name}
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          {row?.clinical_note || "-"}
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          {normalizeLegacyDuration(
                            row?.condition_onset,
                            row?.condition_onset,
                            row?.condition_onset_type
                          )
                            ? `${normalizeLegacyDuration(
                              row?.condition_onset,
                              row?.condition_onset,
                              row?.condition_onset_type
                            )} ago`
                            : "-"}
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          {row?.onset_datetime
                            ? getHumanReadableDiffInPastDateWithAgo(
                              row?.onset_datetime,
                              row
                            )
                            : "-"}
                        </StyledTableCellHistory>
                        {/* <StyledTableCellHistory>
                          {row?.abatement_datetime ?? "-"}
                        </StyledTableCellHistory> */}
                        <StyledTableCellHistory>-</StyledTableCellHistory>
                      </StyledTableRowHistory>
                    );
                  })}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>

        <Grid item xs={11} sm={11}>
          {drugHistoryData["new"].length > 0 && (
            <StyledTableContainer
              component={Paper}
            // sx={{
            //   marginTop: "20px",
            //   border: "1px solid #21cdc0",
            // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Drug Name</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>Drug Onset</StyledTableCellHistory>
                    <StyledTableCellHistory>Duration</StyledTableCellHistory>
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {drugHistoryData["new"].map((row, rowIndex) => {
                    console.log("Drug Row", row); // Logging the row object

                    return (
                      <StyledTableRowHistory key={rowIndex}>
                        <StyledTableCellHistory>
                          {row?.drug_name}
                          {row?.source === "voice" && !row.id && (
                            <Tooltip title="Machine-interpreted text — please verify before confirming">
                              <span className="missing-id-warning">⚠️</span>
                            </Tooltip>
                          )}
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          {row?.clinical_note || "-"}
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          {normalizeLegacyDuration(
                            row?.condition_onset,
                            row?.condition_onset,
                            row?.condition_onset_type
                          )
                            ? `${normalizeLegacyDuration(
                              row?.condition_onset,
                              row?.condition_onset,
                              row?.condition_onset_type
                            )} ago`
                            : "-"}
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          {normalizeLegacyDuration(
                            row?.duration,
                            row?.duration,
                            row?.durationType
                          ) || "-"}
                        </StyledTableCellHistory>
                        {/* <StyledTableCellHistory>
                          {row?.abatement_datetime ?? "-"}
                        </StyledTableCellHistory> */}
                        <StyledTableCellHistory>
                          {drugHistoryData["prev"].includes(row) ? (
                            "-"
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <Tooltip title="Edit">
                                <OutlinedIconFab
                                  onClick={() =>
                                    handleDrugEditClick(row, rowIndex)
                                  }
                                  sx={{ marginRight: 1 }}
                                >
                                  <Icon name="editInTable" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <OutlinedIconFab
                                  onClick={() => handleDrugDelete(rowIndex)}
                                >
                                  <Icon name="deleteInTable" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            </div>
                          )}
                        </StyledTableCellHistory>
                      </StyledTableRowHistory>
                    );
                  })}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default React.memo(DrugHistorySimplified);
